import React from 'react';
import { MktButtonProps } from './button.types';
import { MktButtonStyles, defaultButtonStyles } from './button.styles';
import clsx from 'clsx';

export const MktButton: React.FC<MktButtonProps> = ({
  children,
  variant = 'primary',
  onClick,
}) => {
  return (
    <button
      type="button"
      onClick={onClick}
      className={clsx(MktButtonStyles[variant], defaultButtonStyles)}
    >
      {children}
    </button>
  );
};
